import React, { useState, useEffect } from 'react';
import { useGetAll } from '../hooks/PortabilidadHook';
import {
  KTSVG,
  SimpleAlert,
  LoadingGrid,
  formatDateMonth,
  formatPriceMejorado,
} from '../../../../../_mexablock/helpers';

import {
  downloadExcel,
  downloadPDF,
} from '../../../../service/reportes/Portability';
import { TableList } from '../../../../../_mexablock/helpers/components/TableList';
import { parseAxiosError } from '../../../../service/reportes/AccountStatment';
import { Filter } from '../../activaciones/_modals/Filter';

let fechaActual = new Date();
let fecha_inicio_init = new Date(
  fechaActual.getFullYear(),
  fechaActual.getMonth() - 1,
  1
);
let fecha_fin_init = new Date();

const View: React.FC = () => {
  const [loadingView, setloadingView] = useState(true);
  const [initFilterValues, setInitFilterValues] = useState({
    type_id: 0,
    init_date: '',
    end_date: '',
    filter: 0,
  });
  const [reloadGrid] = useState(Math.random() * 40);
  const { data, loadingRequest } = useGetAll(reloadGrid, initFilterValues);
  const [loadingDownload, setloadingDownload] = useState(false);
  const [loadingDownloadExcel, setloadingDownloadExcel] =
    useState<boolean>(false);

  useEffect(() => {
    if (data.length) {
      setloadingDownload(false);
      setloadingDownloadExcel(false);
    } else {
      setloadingDownload(true);
      setloadingDownloadExcel(true);
    }
  }, [data]);

  useEffect(() => {
    if (loadingRequest > 0) {
      setloadingView(false);
    }
  }, [loadingRequest]);

  const handleFilter = (values: any) => {
    setInitFilterValues(values);
  };
  const handleFilterClean = () => {
    setInitFilterValues({
      type_id: 0,
      init_date: '',
      end_date: '',
      filter: 0,
    });
  };

  const columns: any = [
    {
      id: 'createdAt',
      name: <div className="fw-bolder text-muted me-5">Fecha</div>,
      selector: (row: any) => formatDateMonth(row.createdAt),
      sortable: true,
    },

    {
      id: 'source',
      name: <div className="fw-bolder text-muted me-5">Canal</div>,
      selector: (row: any) => row.source,
      sortable: true,
    },

    {
      id: 'iccid',
      name: <div className="fw-bolder text-muted me-5">ICCID</div>,
      selector: (row: any) => row.iccid,
      sortable: true,
      width: '200px',
    },

    {
      id: 'phone_number',
      name: <div className="fw-bolder text-muted me-5">Núm. portado</div>,
      selector: (row: any) => row.phone_number,
      sortable: true,
    },

    {
      id: 'customer',
      name: <div className="fw-bolder text-muted me-5">Cliente</div>,
      selector: (row: any) =>
        `${row.customer.first_name} ${row.customer.father_last_name}`,
      sortable: true,
      width: '200px',
    },

    {
      id: 'info_operation.is_from_activation',
      name: <div className="fw-bolder text-muted me-5">Monto</div>,

      selector: (row: any) =>
        row.info_operation?.is_from_activation === 1
          ? '$0'
          : formatPriceMejorado(
              row.info_operation?.operation?.amount,
              'es-MX',
              'MXN'
            ),
      sortable: true,
    },

    {
      id: 'usuario_creo',
      name: <div className="fw-bolder text-muted me-5">Usuario</div>,
      selector: (row: any) =>
        `${row.user.first_name} ${row.user.father_last_name}`,
      sortable: true,
      width: '200px',
    },

    {
      id: 'tipo_ejecucion',
      name: <div className="fw-bolder text-muted me-5">Tipo de ejecución</div>,
      selector: (row: any) =>
        row.info_operation.is_from_activation === 1
          ? 'Desde activación'
          : 'Directa',
      sortable: true,
      width: '150px',
    },

    {
      id: 'estatus',
      name: <div className="fw-bolder text-muted me-5">Estatus</div>,
      selector: (row: any) => row.status.name,
      cell: (row: any) => (
        <>
          {row.status.code === 'PEN' && (
            <span className="badge py-3 px-4 fs-7 badge-light-warning">
              {row.status.name}
            </span>
          )}
          {row.status.code === 'PENV' && (
            <span className="badge py-3 px-4 fs-7 badge-light-primary">
              {row.status.name}
            </span>
          )}
          {row.status.code === 'ERR' && (
            <span className="badge py-3 px-4 fs-7 badge-light-danger">
              {row.status.name}
            </span>
          )}
          {row.status.code === 'EXT' && (
            <span className="badge py-3 px-4 fs-7 badge-light-success">
              {row.status.name}
            </span>
          )}
          {row.status.code === 'NMLX' && (
            <span className="badge py-3 px-4 fs-7 badge-light-warning">
              {row.status.name}
            </span>
          )}
        </>
      ),
      sortable: true,
    },
  ];

  const handleDownloadPDF = () => {
    setloadingDownload(true);
    setTimeout(() => {
      downloadPDF(initFilterValues)
        .then(() => {
          setloadingDownload(false);
        })
        .catch(async (error) => {
          setloadingDownload(false);
          const message = await parseAxiosError(error);
          SimpleAlert(message, 4000, 'error');
        });
    }, 2000);
  };

  const handleDownloadExcel = () => {
    setloadingDownloadExcel(true);
    setTimeout(() => {
      downloadExcel(initFilterValues)
        .then(() => {
          setloadingDownloadExcel(false);
        })
        .catch(async (error) => {
          setloadingDownloadExcel(false);
          const message = await parseAxiosError(error);
          SimpleAlert(message, 4000, 'error');
        });
    }, 2000);
  };

  return (
    <>
      <div className="row gy-5 g-xl-8">
        <div className="col-xl-12">
          <div className={`card card-xxl-stretch mb-5 mb-xl-12`}>
            <div className="card-header border-0 pt-5">
              <Filter
                initFilterValues={initFilterValues}
                onCleanFilter={handleFilterClean}
                onSearchFilter={handleFilter}
                showFilterCode={true}
                noAuto={false}
              />
              <div className="card-toolbar">
                <div className="d-flex rounded mt-3">
                  <button
                    className="btn btn-sm btn-light-success"
                    disabled={loadingDownloadExcel}
                    onClick={() => handleDownloadExcel()}
                  >
                    {loadingDownloadExcel && data.length ? (
                      <span
                        className="indicator-progress"
                        style={{ display: 'block' }}
                      >
                        Descargando...
                        <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                      </span>
                    ) : (
                      <>
                        <KTSVG
                          path="/media/icons/duotune/files/fil029.svg"
                          className="svg-icon-5 svg-icon-gray-500 me-1"
                        />
                        Descargar
                      </>
                    )}
                  </button>

                  <button
                    className="btn btn-sm btn-light-danger ms-5"
                    disabled={loadingDownload}
                    onClick={handleDownloadPDF}
                  >
                    {loadingDownload && data.length ? (
                      <span
                        className="indicator-progress"
                        style={{ display: 'block' }}
                      >
                        Descargando...
                        <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                      </span>
                    ) : (
                      <>
                        <KTSVG
                          path="/media/icons/duotune/files/fil030.svg"
                          className="svg-icon-5 svg-icon-gray-500 me-1"
                        />
                        Descargar
                      </>
                    )}
                  </button>
                </div>
              </div>
            </div>
            {loadingView ? (
              <LoadingGrid text="Cargando..."></LoadingGrid>
            ) : (
              <TableList data={data} columns={columns}></TableList>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export { View };
